import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import SetupParentRepository from '@/repositories/setupParentRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useSetupParentStore = defineStore({
    id: 'setupUserParent',
    state: () => ({}),
    getters: {},
    actions: {
        /**
         * 法定代理人(親権者等)同意画面の登録処理。
         */
        async setupUserParentAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const setupParentRepository = new SetupParentRepository();
            try {
                // ユーザー親権者同意情報設定APIをコールする。
                const response = await setupParentRepository.putUserParentActionApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
});
